<template>
  <div class="layout">
    <div class="introduce-wrap">
      <h2 class="title">저작권정책</h2>
      <p class="title-info-txt">
        저작권법 제24조의 2에 따라 문화체육관광부에서 저작재산권의 전부를 보유한 저작물의 경우에는 별도의 이용허락 없이 자유이용이 가능합니다. <br>
        단 자유이용이 가능한 자료는 "공공저작물 자유이용허락 표시기준(공공누리, KOGL) 제1유형"을 부착하여 개방하고 있으므로 공공누리 표시가 부착된 저작물인지를 확인한 이후에 <br>
        자유이용 하시기 바랍니다. 자유이용의 경우에는 반드시 저작물의 출처를 구체적으로 표시하여야 합니다.
      </p>
      <div class="title-info-box">
        <img src="../../assets/img/certification_mark.jpg" alt="공공누리 공공저작물 자유이용허락">
        <p>[ 공공저작물 자유이용허락 표시기준(공공누리, KOGL) 제1유형]</p>
      </div>
      <p class="title-info-txt">
        공공누리가 부착되지 않은 자료들을 사용하고자 할 경우에는 담당자와 사전에 협의한 이후에 이용하여 주시기 바랍니다.
      </p>
      <ul class="introduce-list-box">
        <li>문의 : 문화체육관광부 지능정보화담당관 <br> 044-203-2217</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
	name: 'Copyright'
}
</script>

<style scoped>

</style>
